// * Load myorder script in order history or order history details (one time only in first view)
export const loadMyOrderAssets = (base: string) => {
  const loadScript = (src: string, type?: string) => {
    if (document.querySelector(`script[src="${src}"]`)) return; // Avoid duplicate if present
    const s = document.createElement("script");
    if (type) s.type = type;
    s.src = src;
    s.async = false;
    document.body.appendChild(s);
  };

  loadScript(`${base}/web-component/OrderDetails.js.map`, "importmap");
  loadScript(`${base}/web-component/OrderDetails.js`);
  loadScript(`${base}/web-component/OrderHistory.js.map`, "importmap");
  loadScript(`${base}/web-component/OrderHistory.js`);
};

//* remove var containing filters in my order
export const clearMyOrderSessionStorage = () => {
  sessionStorage.removeItem("enableHandleMyOrderFilter");
  sessionStorage.removeItem("enableHandleMyOrderPagination");
  sessionStorage.removeItem("enableHandleMyOrderActiveDoor");
};
